import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function stopCampaign({ clientId, firebaseFunctions = functions } = {}) {
  const normalizedClientId = String(clientId || '').trim();
  if (!normalizedClientId) {
    throw new TypeError('clientId is required');
  }

  const callable = httpsCallable(firebaseFunctions, 'stopCampaign');
  const response = await callable({ clientId: normalizedClientId });
  return response?.data || {};
}

/**
 * Mark a campaign complete, or un-mark it.
 *
 * ONLY THE CLIENT ID IS SENT. The person who made the decision is read from
 * Firebase Auth on the server -- the backend gate honours a completion marker
 * only when it names a human, and a `markedBy` a browser could supply would
 * hand that fence back to whatever is calling.
 */
async function campaignCompletionCall(name, { clientId, firebaseFunctions = functions } = {}) {
  const normalizedClientId = String(clientId || '').trim();
  if (!normalizedClientId) {
    throw new TypeError('clientId is required');
  }

  const callable = httpsCallable(firebaseFunctions, name);
  const response = await callable({ clientId: normalizedClientId });
  return response?.data || {};
}

export async function completeCampaign(options) {
  return campaignCompletionCall('completeCampaign', options);
}

export async function reopenCampaign(options) {
  return campaignCompletionCall('reopenCampaign', options);
}
